module.exports = __webpack_public_path__ + "static/media/bookr_books.a78632b1.png";